import { assets, view } from '@yola/ws-sdk';
import compute from './helpers/compute';
import isWsBlock from '../../../blocks/verifiers/is-ws-block';
import { BACKGROUND_IMAGE_ATTRIBUTE } from '../../constants/attributes';

const imageIsReplaced = async (config, payload, transaction) => {
  const { elementId, attr, value } = payload;

  if (!elementId || attr !== BACKGROUND_IMAGE_ATTRIBUTE) {
    return [];
  }

  // We need to operate only with liveElement when
  // we work with ws-sitecomponents, to prevent skipping
  // of overlay design-automatization
  const targetBlock = view.accessors.getLiveElement(elementId);

  const { initialState: initialTransactionDOM } = transaction;
  const initialTargetBlock = initialTransactionDOM.getElementById(targetBlock.id);

  if (!targetBlock || !isWsBlock(targetBlock) || !initialTargetBlock) {
    return [];
  }

  const initialBackgroundImage = initialTargetBlock.getAttribute(BACKGROUND_IMAGE_ATTRIBUTE);

  if (value === initialBackgroundImage) {
    return [];
  }

  const parsedValue = value.split(',').pop().trim();
  const mediaSource = assets.helpers.addBaseHref(parsedValue);

  return compute(targetBlock, {
    mediaSource,
  });
};

export default imageIsReplaced;
